import React from 'react';
import { useAppLocale } from '../../providers/LocaleProvider';
import { mirrorRtlDecor } from '../../utils/mirrorRtlDecor';

/** Decorative background layer that mirrors gradients/positioning in fa (RTL) mode. */
export const RtlDecorLayer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => {
  const { direction } = useAppLocale();
  return <div className={mirrorRtlDecor(className ?? '', direction === 'rtl')} {...rest} />;
};
